<template>
  <div class="basic Rescue">
    <commonHeader :title="data.name || name" />
    <div class="content">
      <ul class="table">
        <div class="tableLeft">
          <li>
            <span class="text1">{{ list.checkTimeStop }}</span>
            <span class="text2">{{ Rescue.table1 }}</span>
          </li>
          <li>
            <span class="text1">{{ list.amountLoss }}</span>
            <span class="text2">{{ Rescue.table2 }}</span>
          </li>
          <li>
            <span class="text1 red">{{ list.amountReward }}</span>
            <span class="text2">{{ Rescue.table3 }}</span>
          </li>
        </div>

        <li
          class="tableRight receive"
          @click="receive(1)"
          v-show="list.status === 0 && !buttonShow"
        >
          {{ Rescue.receive }}
        </li>
        <li
          class="tableRight"
          @click="receive(2)"
          v-show="list.status === 1 && !buttonShow"
        >
          {{ Rescue.receive1 }}
        </li>
        <li class="tableRight" @click="receive(3)" v-show="buttonShow">
          {{ Rescue.receive2 }}
        </li>
      </ul>
      <div class="lastTip">
        <div class="title">{{ Rescue.footer1 }}</div>
        <p>{{ Rescue.footer2 }}</p>
        <p>{{ Rescue.footer3 }}</p>
        <p>{{ Rescue.footer4 }}</p>
        <p>{{ Rescue.footer5 }}</p>
        <p>
          {{ Rescue.footer6 }}&nbsp;&nbsp;<span
            class="clickon"
            @click="openDetail()"
            >{{ Rescue.footer7 }}</span
          >&nbsp;&nbsp;{{ Rescue.footer8 }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import commonHeader from "./commonHeader.vue";
export default {
  components: {
    commonHeader,
  },
  data() {
    return {
      list: {},
      buttonShow: false,
      data: {},
      name: "",
      betNo:'',
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.name = this.$route.query.name;
    this.getData(this.id);
  },
  computed: {
    Rescue() {
      return this.$t("Rescue");
    },
  },
  methods: {
    openDetail() {
      this.$router.push({
        path: "/discount",
        query: {
          flag: true,
          name: this.data.name,
          startTime: this.data.startTime,
          endTime: this.data.endTime,
          forever: this.data.forever,
        },
      });
      localStorage.setItem("disIntro", this.data.intro);
    },
    getData(id) {
      let that = this;
      this.$http
        .get(this.$api.getThematicActivitiesByApp, "/" + id, true)
        .then((res) => {
          if (res.code == 0) {
            that.data = res.data;
            if (res.data.compensationVO.receivedList.length !== 0) {
                that.betNo = res.data.compensationVO.receivedList[0].recordsNumber;
              that.list = res.data.compensationVO.receivedList[0];
              let yesday = new Date(that.list.checkTimeStop); // 获取的是前一天日期
              that.list.checkTimeStop =
                (yesday.getMonth() > 9
                  ? yesday.getMonth() + 1
                  : yesday.getMonth() + 1) +
                "-" +
                (yesday.getDate() > 9
                  ? yesday.getDate()
                  : "0" + yesday.getDate());

              that.buttonShow = false;
            } else {
              let time = new Date().getTime() - 24 * 60 * 60 * 1000;
              let yesday = new Date(time); // 获取的是前一天日期
              that.list.checkTimeStop =
                (yesday.getMonth() > 9
                  ? yesday.getMonth() + 1
                  : yesday.getMonth() + 1) +
                "-" +
                (yesday.getDate() > 9
                  ? yesday.getDate()
                  : "0" + yesday.getDate());
              that.list.amountLoss = 0.0;
              that.list.amountReward = 0.0;
              that.buttonShow = true;
            }
          } else {
            let time = new Date().getTime() - 24 * 60 * 60 * 1000;
            let yesday = new Date(time); // 获取的是前一天日期
            that.list.checkTimeStop =
              (yesday.getMonth() > 9
                ? yesday.getMonth() + 1
                : yesday.getMonth() + 1) +
              "-" +
              (yesday.getDate() > 9
                ? yesday.getDate()
                : "0" + yesday.getDate());
            that.list.amountLoss = 0.0;
            that.list.amountReward = 0.0;
            that.buttonShow = true;
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    receive(val) {
        let that = this;
        if (val === 1) {
            that.$http.put(
                    this.$api.getReceive + that.id + "&betNo=" + that.betNo
                ).then((res) => {
                if (res.code == 0) {
                    that.$message({
                        message: res.data,
                        type: "success",
                    });
                    that.getData(that.id);
                } else {
                    that.$message({ type: "warning", message: res.msg });
                }
            });
        } else if (val === 2) {
            this.$message({
                message: that.Reward.message2,
                type: "warning",
            });
        } else if (val === 3) {
            this.$message({
                message: that.Reward.receive2,
                type: "warning",
            });
        }
    },
  },
};
</script>
<style lang="scss" scoped>
    @import url('../../../assets/css/common.css');
.Rescue {
  .headTip {
    margin: 20px 0;
    background-color: #fff4d7;
    color: #e91919;
    font-size: 12px;
    padding: 10px;
  }
  .content {
    .table {
      width: 100%;
      height: 80px;
      background-color: #ffffff;
      border: 1px solid #dcdcdc;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .tableLeft {
        display: flex;
        justify-content: space-around;
        padding-left: 20px;
        box-sizing: border-box;
        li {
          display: flex;
          flex-direction: column;
          margin-right: 110px;
          .text1 {
            color: #333333;
            font-size: 20px;
          }
          .text2 {
            color: #999999;
            font-size: 12px;
            margin-top: 5px;
          }
          .red {
            color: #e91919;
          }
        }
      }
      .tableRight {
        width: 118px;
        height: 36px;
        margin-right: 16px;
        background: #f5f5f5;
        border: 1px solid #e6e6e6;
        border-radius: 2px;
        text-align: center;
        line-height: 36px;
        color: #999999;
        font-weight: 500;
      }
      .receive {
        background-color: #e91919;
        color: #ffffff;
        border: none;
      }
    }

    //温馨提示样式
    .lastTip {
      .title {
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        color: #e91919;
        margin-top: 50px;
      }
      p {
        font-size: 12px;
        font-family: PingFang SC;
        line-height: 25px;
        color: #333333;
        line-height: 2.5;
      }
      .clickon {
        color: #517ae9;
      }
    }
  }
}
</style>
